export const mobility_policy_framework = [
  {
    id: 1,
    name: '9057-wc-registration-licence-fees-2025-1',
    summary: 'shortsummary/9057-wc-registration-licence-fees-2025-1.html',
    link: '9057-wc-registration-licence-fees-2025-1.pdf',
    audio_en: 'audio/en/9057-wc-registration-licence-fees-2025-1_en.mp3',
    audio_af: 'audio/af/9057-wc-registration-licence-fees-2025-1_af.mp3',
    audio_xh: 'audio/xh/9057-wc-registration-licence-fees-2025-1_xh.mp3'
  },
  {
    id: 2,
    name: 'final-wcmd-strategic-plan-2025_2030',
    summary: 'shortsummary/final-wcmd-strategic-plan-2025_2030.html',
    link: 'final-wcmd-strategic-plan-2025_2030.pdf',
    audio_en: 'audio/en/final-wcmd-strategic-plan-2025_2030_en.mp3',
    audio_af: 'audio/af/final-wcmd-strategic-plan-2025_2030_af.mp3',
    audio_xh: 'audio/xh/final-wcmd-strategic-plan-2025_2030_xh.mp3'
  }
];